import { render, staticRenderFns } from "./docterCard.vue?vue&type=template&id=5ca754e6&scoped=true"
import script from "./docterCard.vue?vue&type=script&lang=js"
export * from "./docterCard.vue?vue&type=script&lang=js"
import style0 from "./docterCard.vue?vue&type=style&index=0&id=5ca754e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ca754e6",
  null
  
)

export default component.exports